export const accountMovement = {
  accountMovementTransaction: "交易",
  accountMovementAmount: "金额",
  accountMovementDeposit: "存款",
  accountMovementTransfer: "转账",
  accountMovementBet: "投注",
  accountMovementWithdrawal: "提款",
  accountMovementBonus: "奖金",
  movementsBtnBack: "返回",
  accountMovementBetAll: "全部",
  accountMovementBetWon: "获胜",
  accountMovementBetLost: "失败",
  paginationItemsPerPage: "/ 页",
  paginationJumpTo: "跳至",
  paginationJumpToConfirm: "确定",
  paginationPage: "页",
  paginationPrevPage: "上一页",
  paginationNextPage: "下一页",
  paginationPrev5: "向前 5 页",
  paginationNext5: "向后 5 页",
  paginationPrevPageTooltip: "上一页",
  paginationNextPageTooltip: "下一页",
  paginationOf: "共",
  paginationItems: "条",
};
